define(['text!./templates/quote-details-box.html', 'edge/platform/base/BaseCtrl'],
    (templateStr, BaseCtrl)=> {
        return [()=> {
            return {
                restrict: 'A',
                scope: {
                    buy: '=',
                    quote: '=gwQnbQuoteDetailsBox',
                },
                template: templateStr,
                controller: ['$scope', 'StateUtils', (scope, StateUtils)=> {

                    const ctrl = Object.create(BaseCtrl);
                    const flowModel = StateUtils.activeDataForState(true).flowModel;

                    ctrl.init = function () {
                        if (!flowModel) {
                            return;
                        }

                        scope.paymentPeriod = 'fullTerm';
                        scope.buyQuote = ()=> {
                            const termInMonths = (scope.paymentPeriod === 'fullTerm') ? scope.quote.termMonths : 1;
                            scope.buy(scope.quote, termInMonths);
                        };
                    };
                    /**
                     * Method used by wizard ribbon to move between steps.
                     * @param {Object} step - selected step
                     */
                    ctrl.selectStep = function (step) {
                        const currentModel = StateUtils.activeDataForState(true).model;
                        if (flowModel.isStepAccessibleFromCurrent(step)) {
                            flowModel.jumpToStep(step, currentModel);
                        }
                    };

                    return ctrl.create(scope);
                }],
            };
        }];
    });


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/directives/QuoteDetailsBox.js